import { GatsbySeo } from 'gatsby-plugin-next-seo'
import RenderPageSections from 'src/components/cms/RenderedPageSections'
import { RecommendationProvider } from 'src/components/restructure/product/contexts/Recommendations/recommendations-context'
import type { ServerData } from 'src/utils/getCampanhaTemplateServerData'

type SiteMetadata = {
  siteMetadata: {
    siteUrl: string | null
    ogImage: string | null
  } | null
} | null

export type CampanhaTemplateProps = {
  serverData: ServerData['serverData']
  location: { pathname: string }
  data: { site: SiteMetadata }
}

export function CampanhaTemplate({
  serverData,
  data: { site },
  location: { pathname },
}: CampanhaTemplateProps) {
  const { cmsData } = serverData

  if (serverData === null) {
    return null
  }

  const seo = cmsData?.seo?.siteMetadataWithSlug

  const hasDYShelfOnSections = cmsData?.sections?.some(
    (section) =>
      section.name === 'Vitrine DY [LP]' ||
      section.name === '[Campanhas 2.0] Vitrine Large'
  )

  return (
    <>
      <GatsbySeo
        title={seo?.title ?? ''}
        description={seo?.description ?? ''}
        canonical={`${site?.siteMetadata?.siteUrl}${pathname}`}
        openGraph={{
          images: [{ url: site?.siteMetadata?.ogImage ?? '' }],
          type: 'website',
          url: `${site?.siteMetadata?.siteUrl}${pathname}`,
          title: seo?.title,
          description: seo?.description,
        }}
      />
      <RecommendationProvider
        pageName="landingpage"
        engines={hasDYShelfOnSections ? ['dy'] : []}
      >
        <RenderPageSections sections={cmsData?.sections} />
      </RecommendationProvider>
    </>
  )
}

export default CampanhaTemplate
